"use strict";
// --- These are the message keys used for the socket communication
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    augur: {
        created: 'augur.created',
        progress: 'augur.progress',
    },
    dataConnection: {
        created: 'dataConnection.created',
    },
    habitat: {
        created: 'habitat.created',
    },
    prediction: {
        started: 'prediction.started',
    },
    datapool: {
        created: 'datapool.created',
        progress: 'datapool.progress',
    },
    cassandraKeyspace: {
        created: 'cassandraKeyspace.created',
    },
    jobProgress: {
        update: 'progress_update',
    },
    jobEvents: {
        update: 'events_update',
    },
    jobStatus: {
        update: 'status_update',
    },
    jobLog: {
        appendLines: 'log_append_lines',
    },
};
//# sourceMappingURL=socketTypes.js.map